import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import base64 from 'base64-arraybuffer';
import hkdf from './hkdf';
import sha256 from './sha-256';
import { stringToArrayBuffer } from './utils';
var HMAC_KEY_NAME = 'authentication';
var ALGORITHM_NAME = 'HMAC';
var KEY_IS_EXTRACTABLE = false;
var KEY_WILL_BE_USED_TO_SIGN = ['sign'];
var KEY_WILL_BE_USED_TO_SIGN_AND_VERIFY = ['sign', 'verify'];

var importKeyFromMaster = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(masterKey, salt) {
    var hmacKey;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return window.crypto.subtle.deriveKey(hkdf.getParams(HMAC_KEY_NAME, salt), masterKey, {
              name: ALGORITHM_NAME,
              hash: {
                name: sha256.HASH_ALGORITHM_NAME
              },
              length: 512 // need to explicitly set length for WebCrypto node polyfill (see: https://github.com/PeculiarVentures/webcrypto-core/issues/31)

            }, KEY_IS_EXTRACTABLE, KEY_WILL_BE_USED_TO_SIGN);

          case 2:
            hmacKey = _context.sent;
            return _context.abrupt("return", hmacKey);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function importKeyFromMaster(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var importKeyFromRawBits = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(rawBits) {
    var hmacKey;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return window.crypto.subtle.importKey('raw', rawBits, {
              name: ALGORITHM_NAME,
              hash: {
                name: sha256.HASH_ALGORITHM_NAME
              },
              length: 256 // need to explicitly set length for WebCrypto node polyfill (see: https://github.com/PeculiarVentures/webcrypto-core/issues/31)

            }, KEY_IS_EXTRACTABLE, KEY_WILL_BE_USED_TO_SIGN_AND_VERIFY);

          case 2:
            hmacKey = _context2.sent;
            return _context2.abrupt("return", hmacKey);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function importKeyFromRawBits(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 *
 * @param {CryptoKey} key
 * @param {String} data
 */


var sign = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key, data) {
    var result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return window.crypto.subtle.sign({
              name: ALGORITHM_NAME
            }, key, data);

          case 2:
            result = _context3.sent;
            return _context3.abrupt("return", result);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function sign(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 *
 * @param {CryptoKey} key
 * @param {String} data
 */


var signString = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(key, data) {
    var result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return sign(key, stringToArrayBuffer(data));

          case 2:
            result = _context4.sent;
            return _context4.abrupt("return", base64.encode(result));

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function signString(_x6, _x7) {
    return _ref4.apply(this, arguments);
  };
}();

export default {
  importKeyFromMaster: importKeyFromMaster,
  importKeyFromRawBits: importKeyFromRawBits,
  sign: sign,
  signString: signString
};